<div class="content d-flex flex-column vi-gap-24">
  <headline-with-icon [headline]="headline" [icon]="icon"></headline-with-icon>
  <div>
    <mat-card>
      <mat-card-content>
        <span class="semiBold" [innerHTML]="infoBoxHeadline"></span><br>
        <br *ngIf="infoBoxText">
        <span *ngIf="infoBoxText" [innerHTML]="infoBoxText"></span>
      </mat-card-content>
    </mat-card>
  </div>
</div>

